module.exports = __webpack_public_path__ + "img/arrow-down.1b257e33.svg";